import React from "react";
import {Link} from "react-router-dom";
import axios from "axios"
import {deleteBook} from "./action/books";
import {connect} from "react-redux";

class ABookPage extends React.Component{
    state={
        "ov": false,
        loading: false
    };
    componentDidMount(){
        if(this.props.match.params.bookId){
        axios.defaults.headers.common['bookid'] = this.props.match.params.bookId;
        }
    }
    deleteBook = e => {
        this.setState({loading: true});
        var arr = this.props.books;
        arr.splice(this.props.match.params.bookId, 1);
        for(var i = 0; i < arr.length; i++){
            arr[i].bookId=i;
        }
        this.props.deleteBook({arr: arr, totalBooks: arr.length}).then(msg => {
            this.props.history.push("/main");
            window.location.reload();
        });
    };

    startReading = () =>{
        this.props.history.push("/main/books/readBook"+this.props.books[this.props.match.params.bookId].book_type+"/"+this.props.match.params.bookId);
    };
    editBook = () =>{
        this.props.history.push("/main/editBook/"+this.props.books[this.props.match.params.bookId].book_type+"/"+this.props.match.params.bookId);
    };
    render(){
        const {deleteBook, startReading, editBook} = this;
        window.onscroll = function() {scrollFunction()};
        var scrollFunction = () => {
            if (document.body.scrollTop > 1 || document.documentElement.scrollTop > 3) {
                this.setState({"ov": true});
            }else{
                this.setState({"ov": false});
            }
        }
        return(
            <div className="aBookPage">
            {!this.state.loading && this.props.books ? (
                    <div className="left">
                    <div id="top">
                        {this.props.books[this.props.match.params.bookId].book_cover &&
                        <img src={"/root/user/"+this.props.books[this.props.match.params.bookId].book_cover} alt="SSSSSSsss"/>}
                        <div id="content">
                            <h1> {this.props.books[this.props.match.params.bookId].book_title} </h1>
                            <button id="startReading" onClick={startReading}> Start Reading </button><br/><br/>
                            <button id="editBook" onClick={editBook}> Edit Book </button>
                            <div className="bookList">
                            <p> <b>In the Booklist:</b> {this.props.books[this.props.match.params.bookId].bookList} </p>
                            <button id="change"> Change </button>
                            </div>
                        </div>
                    </div>
                    <h3> {this.props.books[this.props.match.params.bookId].book_description} </h3>
                </div>
                
                ):<div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>} {this.state.loading && (
                    <div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>
                    )}{!this.state.loading && (
                        <div>
                    <div>
                        <div className={this.state.ov ? "ov dbb": "ov"} onClick={() => {this.setState({"ov": false})}}></div>
                        <div className={this.state.ov ? "right": "right d"}>
                            <h1>More Options</h1>
                            {this.props.books && this.props.books.length === this.props.totalBooks && <Link to={this.props.books && this.props.books.length === this.props.totalBooks && "/main/editBook/"+this.props.books[this.props.match.params.bookId].book_type+"/"+this.props.match.params.bookId}><button id="editBookMetaData"> Edit Book Meta Data </button></Link>}
                            <button id="deleteBook" onClick={deleteBook}> Delete Book </button>
                        </div>
                        </div>
                <p className="scroll"> Scroll Down to See More Options </p></div>)}
            </div>
        );
    }
};

// const booksArray = [
//                 {"id": "1","title": "Marigold", 
//                 "description": "This is the Description of the Book. Click on this Book Component to view more. It will open a new window",
//                 "chapters": "40", 
//                 "pages": "110",
//                 "bookList": "Class 4", 
//                 "type": "PDF", 
//                 "imageSrc": "https://bn1305files.storage.live.com/y4merdutAU-qnW7qtMPSd1DuBSPElKc0FFWiCThL37NYTPXjFKrYov2N0449feeMGA09BYufO9NlBkulweJm1APpKaY1Zn9-GJr95CArH-8iXmPARR6RzSV6oMqG6wEZw2w2Au2rHh7YmuU8G3Bjvv8paxXb2rxUfhXMHG8gANKuTO6g0Q1hTx4YpFuKOepLsEw?width=1500&height=2010&cropmode=none"},
               
//                 {"id": "2","title": "The Art Of Software Testing", 
//                 "description": "This is the Description of the Book. Click on this Book Component to view more. It will open a new window",
//                 "chapters": "151", 
//                 "pages": "509", 
//                 "bookList": "Software Testing",
//                 "type": "PDF", 
//                 "imageSrc": "https://bn1305files.storage.live.com/y4mwn52L-eanuKML0gLxGrVu60cTFm2zZv-LFJRLJ1Cc5i6L-6OF7IUvXAauqB-KWvanpWJly4pmRgY10RyAuOsbSIiXR7fHLYtG67PJcCXyIG4n_aymfWAzj5RBKkEmUfGkcUVgC1CRTxkt7Xz8RR0u4MRPI90zoTYHX7Cp6pyfKSGCJHUfFHTRYtKUPyZ2NQZ?width=333&height=499&cropmode=none"},
                
//                 {"id": "3","title": "Operating System Concepts", 
//                 "description": "This is the Description of the Book. Click on this Book Component to view more. It will open a new window",
//                 "chapters": "243", 
//                 "pages": "909",
//                 "bookList": "Computer Science", 
//                 "type": "PDF", 
//                 "imageSrc": "https://bn1305files.storage.live.com/y4mhIa7vf_8nYgOQMO9MVac-147dyc7O4c7aElCYxiHPRAfWu_MwuyUpyvVmwD1siXPIL5bnR5KsBb9JxcCYCqxNrQyil61bxgACJhQdDY2qzinoHsusPUIlw6nIsCL6Iur3HeKia6EIo-G0jIPg_wk4K36uY7gtq15_2bzuXwiLBWjZfRMre4rJz8DhB4Sj-V8?width=342&height=500&cropmode=none"},
//                 {"id": "4","title": "C++", 
//                 "description": "This is the Description of the Book. Click on this Book Component to view more. It will open a new window",
//                 "chapters": "151", 
//                 "pages": "509", 
//                 "bookList": "Computer Science",
//                 "type": "PDF", 
//                 "imageSrc": "https://bn1305files.storage.live.com/y4mKn7RQioz8UkBVBbdpEvmutdaWGLQ_DiDBJZX4ir64fRKrjZixAJdivzrzsbYC65FZQm5pAFeOWcmMWzMbPL5HdNMvlvQLfqhykGqjMVSQwmxNr8UXYwEmI2Z16DrPCBdQogqUc3mvdKY07vsuG5JGS1sTCbrzu7Mwm-qzDNm3BJoGypPbb6yQjl2bt0TgThM?width=384&height=499&cropmode=none"}];

function mapStateToProps (state) {
    return {books: state.AllBooks.books, totalBooks: state.user.totalBooks}
}

export default connect(mapStateToProps, {deleteBook})(ABookPage);